/**
 * Centralized navigation service for consistent routing
 */

export const navigationService = {
  // Global routes
  settings: () => '/settings',
  
  // Project-specific routes
  project: (projectId: string) => `/projects/${projectId}`,
  projectAssistant: (projectId: string) => `/projects/${projectId}/assistant`,
  projectWithTable: (projectId: string, tableId: string) => `/projects/${projectId}?table=${tableId}`,
  projectCreate: (projectId: string) => `/projects/${projectId}?create=true`,
  
  // Utility functions
  isProjectRoute: (pathname: string) => pathname.includes('/projects/'),
  extractProjectId: (pathname: string) => {
    const match = pathname.match(/\/projects\/([^/?]+)/);
    return match ? match[1] : null;
  },
  
  // Check if current path matches route
  isActive: (pathname: string, route: string) => {
    return pathname === route || pathname.startsWith(route + '/');
  }
};

export type NavigationService = typeof navigationService;
